import intialState from './MonitorInitialState';
import reducers from './MonitorReducer';

export default {
  intialState,
  reducers,
};
